var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',[_c('v-autocomplete',{attrs:{"label":_vm.label,"prepend-icon":_vm.icon,"items":_vm.theProdutos,"multiple":_vm.multiple,"item-text":"descricao","return-object":""},on:{"click":_vm.selectAllProducts,"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }